module.exports = __webpack_public_path__ + "img/register_pc_05.7a37b5d0.png";